/**
 * ErrorBoundary
 * 
 */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './ErrorBoundary.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return /*#__PURE__*/_jsxs("div", {
        className: "ErrorBoundary",
        children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: "triangle-exclamation"
        }), /*#__PURE__*/_jsxs("div", {
          className: "apologies",
          children: [/*#__PURE__*/_jsx("h2", {
            children: "Whoops! Something went wrong."
          }), /*#__PURE__*/_jsx("p", {
            children: "We're terribly sorry, but an error has occurred."
          }), /*#__PURE__*/_jsx("p", {
            children: "Try reloading the page."
          })]
        })]
      });
    }
    return this.props.children;
  }
}
export default ErrorBoundary;